module.exports = __webpack_public_path__ + "img/gallery-frame04.4935f4cb.png";